import moment from 'moment';

import Base from './Base';

export default class Sidebar extends Base {
    constructor(props) {
        super();

        this.import(props);
    }

    import(props) {
        this.id = this.assign('id', props);
        this.name = this.assign('name', props);
        this.definition = this.assign('definition', props);
        this.active = this.assign('active', props, 'bool');
        this.createdAt = props.createdAt ? moment(props.createdAt) : this.createdAt;
        this.updatedAt = props.updatedAt ? moment(props.updatedAt) : this.updatedAt;
    }

    export() {
        return {
            id: this.id,
            name: this.name,
            definition: this.definition,
            active: this.active
        }
    }

    toTableRow() {
        return [
            this.id,
            this.name,
            this.active,
            this.createdAt,
            this.updatedAt
        ]
    }
}
